import React, {useState} from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from 'reactstrap'

import { getDisplayName } from '../utils';

function Avatar({className, id="", name = "", lastName = "", size = "xs", onClick, tooltip, tooltipProps}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  if (!name.length && !lastName.length) {
    return <></>
  }

  return (
    <>
      { tooltip && 
        <Tooltip trigger="hover focus" placement="bottom" isOpen={tooltipOpen} toggle={toggle} target={`Tooltip-${id}`}>
          <div className="text-capitalize">
            {getDisplayName(name, lastName)}
          </div> 
          { tooltipProps?.status &&
            <div>
              {tooltipProps?.status}
            </div>
          }
        </Tooltip>  
      }
      
      <div className={`avatar-circle-${size} ${className}`} onClick={onClick} id={`Tooltip-${id}`}>
        <span className="initials">{name?.charAt(0)?.toUpperCase()}{lastName?.charAt(0)?.toUpperCase()}</span>
      </div>
    </>
  )
}

Avatar.propTypes = {

}

export default Avatar

